import { dialog } from "../../../../nq-component";
import React, { useState } from "react";

function DialogConfirmation({ handleAssign }) {
  function _handleAssign() {
    handleAssign();
  }

  return (
    <>
      <form onSubmit={() => _handleAssign()}>
        <div className="p-4">
          <div className="d-flex align-items-center gap-3">
            <div className="align-self-start">
              <i
                class="bi bi-question-circle fs-2 px-2 py-1 rounded"
                style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
              ></i>
            </div>
            <div className="d-flex flex-column mt-2">
              <h5 className="fw-bold" style={{ color: "#D18237" }}>
                Confirmation
              </h5>
              <div className="ms-2 me-1">
                <p className="mt-2">
                  <span className="text-muted">
                    Are you sure you don't want to hire this applicant?
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mb-3">
          <>
            <>
              <button
                className="btn"
                style={{ backgroundColor: "#e8ecf3" }}
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn text-white ms-2"
                style={{ backgroundColor: "#D18237" }}
                // onClick={() => _handleAssign()}
              >
                Confirm
              </button>
            </>
          </>
        </div>
      </form>
    </>
  );
}

export default DialogConfirmation;
